module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "icp-modal",
    attrs: {
      "name": _vm.modalName,
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 680
    },
    on: {
      "before-close": _vm.onBeforeClose
    }
  }, [_c('div', {
    staticClass: "icp-dialog"
  }, [_c('div', {
    staticClass: "icp-dialog-header"
  }, [_c('div', {
    staticClass: "icp-dialog-header-left"
  }, [_c('span', {
    staticClass: "icp-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "21 15 16 10 5 21"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "icp-dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "icp-dialog-sub"
  }, [_vm._v(_vm._s(_vm.subtitle))])])]), _vm._v(" "), _c('button', {
    staticClass: "icp-close-btn",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "icp-dialog-body"
  }, [_c('div', {
    staticClass: "icp-crop-area"
  }, [(_vm.sourceUrl) ? _c('VueCropper', {
    ref: "cropper",
    staticClass: "icp-cropper",
    attrs: {
      "src": _vm.sourceUrl,
      "aspect-ratio": _vm.aspectRatio,
      "view-mode": 1,
      "auto-crop-area": 0.85,
      "background": false,
      "responsive": true,
      "rotatable": false,
      "scalable": false,
      "zoomable": true,
      "alt": "Source image"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "icp-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "icp-dialog-footer"
  }, [_c('button', {
    staticClass: "icp-cancel-btn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "icp-save-btn",
    on: {
      "click": _vm.confirmCrop
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]), _vm._v("\n        Use Selection\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0db57dcb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/ImageCropPreviewModal.vue
// module id = 1655
// module chunks = 2